import { LoadingButton } from "@mui/lab";
import {
  Box,
  Button,
  Popover,
  Stack,
  TableCell,
  TableRow,
  Typography,
} from "@mui/material";
import React from "react";
import { useSelector } from "react-redux";
import { dispatch } from "store";
import { deleteSmsAssignmentsToMachineThunk } from "store/reducers/third_party/smsProviderAllocationSlice";

const AlertAllocationItem = ({ item }) => {
  const { status } = useSelector((state) => state.smsAssignments);
  const removeSmsAssignment = (id) => {
    dispatch(deleteSmsAssignmentsToMachineThunk(id));
  };
  const [anchorEl, setAnchorEl] = React.useState(null);

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };
  const open = Boolean(anchorEl);
  return (
    <>
      <TableRow
        key={item.id}
        sx={{
          "&:last-child td, &:last-child th": { border: 0 },
        }}
      >
        <TableCell component="th" scope="row" align="left">
          {item.service_detail.name}
        </TableCell>
        <TableCell component="th" scope="row" align="center">
          {item.service_detail.code}
        </TableCell>
        <TableCell component="th" scope="row" align="center">
          {item.service_type}
        </TableCell>
        <TableCell align="center" component="th" scope="row">
          {item.authentication ? (
            <Button
              variant="text"
              onClick={(e) => {
                handleClick(e);
              }}
            >
              View
            </Button>
          ) : (
            "-"
          )}
        </TableCell>

        <TableCell align="right" sx={{ width: 30 }}>
          <LoadingButton
            variant="outlined"
            color="error"
            onClick={() => {
              removeSmsAssignment(item.id);
            }}
            loading={status?.loading === "delete" && status?.id === item.id}
          >
            Delete
          </LoadingButton>
        </TableCell>
      </TableRow>
      {item.authentication && (
        <Popover
          id={item.id}
          open={open}
          anchorEl={anchorEl}
          onClose={handleClose}
          anchorOrigin={{
            vertical: "bottom",
            horizontal: "left",
          }}
        >
          <Stack direction="column" padding={2} >
            {Object.entries(item.authentication).map(([k, v]) => (
              <Typography key={k} variant="overline">
                {k} : {v}
              </Typography>
            ))}
          </Stack>
        </Popover>
      )}
    </>
  );
};

export default AlertAllocationItem;
